import { useEffect } from "react";
import { subscribeEvents } from "../api/wsApi";

export default function useWsEvents(handler) {
    useEffect(() => {
        if (!handler) {
            return undefined;
        }
        return subscribeEvents(handler);
    }, [handler]);
}
